import * as React from "react";
import {Autocomplete,TextField } from "@mui/material";
import { useLabelEditorState } from "../hooks/useLabelEditorState";

export default function ComboBox({
  labels,
  boardId,
  cardId,
  setShowLabel,
}) {
  const {
    inputValue,
    selectedLabels,
    options,
    isError,
    handleInputChange,
    handleKeyDown,
    handleBlur,
    handleTextChange,
  } = useLabelEditorState({
    labels,
    boardId,
    cardId,
    setShowLabel,
  });

  return (
    <Autocomplete
      multiple
      autoFocus
      options={options}
      value={selectedLabels}
      inputValue={inputValue}
      onChange={handleInputChange}
      onInputChange={handleTextChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      id="size-small-outlined-multi"
      size="small"
      disablePortal
      sx={{
        width: "100%",
        height: "32px",
        marginRight: "0px",
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              autoFocus: true,
            }}
            error={!!isError}
            helperText={isError && "Max. limit 30 characters"}
            className="label-search-input"
            sx={{
              "& .MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-16px", // Moves error below the field
                background: "white", // Prevents overlay issues
                zIndex: 1301, // Ensures it's above the dropdown
              },
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                zIndex: 999,
              },
            }}
          />
        );
      }}
    />
  );
}
